import triggerEvent from './trigger-event';
import requestFeatureFlags from './request-feature-flags';

export default {
  triggerEvent,
  requestFeatureFlags,
};
